import Message from './models'

export default Message
